// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@tps/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { formatCategories } from "@tps/App/GoogleAnalyticsConnector/Utilities/formatCategories";
import { CustomAppState } from "@tps/App/Store/Reducers";

export const _GaSaveCart = (props: any) => {
    const state = props.getState() as xGoogleAnalyticsState;
    const session = getSession(state);
    const currentBillTo = getCurrentBillToState(state).value;
    const dataLayer = getDataLayer();
    const cart = getCurrentCartState(props.getState()).value;
    const poNumber = (props.getState() as CustomAppState)?.xCheckout?.poNumber || "";

    if (
        !dataLayer ||
        props.result?.errorMessage ||
        !props.parameter.onSuccess ||
        !state.xGoogleAnalytics.saveCartEvent
    ) {
        return;
    }

    const lines = cart?.cartLines?.map((cartLine: CartLineModel) => {
        return {
            productId: cartLine.productId,
            productName: cartLine.productName,
            qtyOrdered: cartLine.qtyOrdered,
            pricing: cartLine.pricing,
            brand: cartLine?.brand,
            categoryTree: cartLine?.properties?.categoryTree,
            variant: cartLine?.properties?.varientValue,
        };
    });

    const googleAnalyticsData = {
        event: state.xGoogleAnalytics.saveCartEventName,
        purchase_order_number: poNumber,
        currency: session.currency?.currencyCode,
        value: cart?.orderSubTotal,
        company_name: currentBillTo?.companyName || "",
        user: session?.userProfileId || "",
        customer_number: currentBillTo?.customerNumber,
        cart_value: cart?.orderSubTotal,
        customer_id: session?.billToId,
        items: lines?.map((line: any, index: number) => ({
            item_id: line.productId || "",
            item_name: line.productName || "",
            affiliation: currentBillTo?.companyName || "",
            coupon: cart?.promotionCode || "",
            discount: line.pricing
                ? line.pricing.unitNetPrice < line.pricing.unitListPrice
                    ? line.pricing.unitListPrice - line.pricing.unitNetPrice
                    : 0
                : 0,
            index,
            item_brand: line.brand || "",
            item_list_id: "",
            item_list_name: "",
            item_variant: line.variant || "",
            location_id: (session as any)?.pickUpWarehouse?.id || "",
            price: line.pricing?.unitNetPrice || 0,
            quantity: line.qtyOrdered,
            ...formatCategories(line?.categoryTree),
        })),
    };
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, PopulateApiParameter, _GaSaveCart);
